import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import { useStyles, styles } from '../SystemScreenStyles';
import { Icon, Table, Tooltip } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { employeeById } from 'app/reducers';
import * as SystemActions from '../../../actions/SystemActions';

const TableScreen = (props) => {
    let { dtsize } = props;
    const classes = useStyles();
    const dispatch = useDispatch();
    const { siteId } = useSelector(state => state.Auth)

    const employeeData = useSelector(employeeById);

    const {
        listSystems,
        isLoadListSystems,
        pagination,
        filter
    } = useSelector(state => state.SystemReducer);

    const dataSource = listSystems.map(
        (record) => {
            return {
                'key': record.idSystem,
                'idSystem': record.idSystem,
                'systemName': record.systemName,
                'keyUser': record.keyUser,
                'functional': record.functional,
                'description': record.description,
                'canDelet': record.canDelet
            }
        }
    );

    const paginationTable =
    {
        defaultCurrent: 1,
        defaultPageSize: 25,
        current: pagination.current,
        pageSize: pagination.pageSize,
        total: pagination.total,
        showSizeChanger: true,
        pageSizeOptions: ['25', '50', '100'],
        showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let obj = {
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
            column: Object.keys(sorter).length > 0 ? sorter.field : undefined,
            order: Object.keys(sorter).length > 0 ? (sorter.order === "ascend" ? 'ASC' : 'DESC') : undefined
        }

        dispatch(SystemActions.savePagination(obj));

        dispatch(SystemActions.fetchSystems({
            subdirectionorigin: employeeData.idSubdirection,
            offset: (pagination.current - 1) * pagination.pageSize,
            limit: pagination.pageSize,
            sortColumn: Object.keys(sorter).length > 0 ? sorter.field : undefined,
            sortDir: Object.keys(sorter).length > 0 ? (sorter.order === "ascend" ? 'ASC' : 'DESC') : undefined,
            listName: props.FiltroSistemas.join(','),
            listKeyUser: props.FiltroKeyUser.join(','),
            listFunctional: props.FiltroFuncional.join(',')
        }))
    }

    const columns = [
        {
            title: 'Nombre',
            dataIndex: 'systemName',
            key: 'systemName',
            sorter: true,
            ellipsis: true,
            width: 250

        },
        {
            title: 'KeyUser',
            dataIndex: 'keyUser',
            key: 'keyUser',
            sorter: true,
            ellipsis: true,
            width: 300

        },
        {
            title: 'Funcional',
            dataIndex: 'functional',
            key: 'functional',
            sorter: true,
            ellipsis: true,
            width: 300
        },
        {

        },
        {
            title: 'Acciones',
            key: 'action',
            dataIndex: 'idSystem',
            fixed: 'right',
            width: 120,
            render: (text, record) => (
                <div className={classes.buttons}>
                    {/* <IconButton>
                        <Icon type="schedule" />
                    </IconButton> */}
                    {
                        siteId === "HUB" ?
                            <Tooltip title="Eliminar">
                                <IconButton disabled={!record.canDelet} className={classes.deleteIcon} onClick={() => props.showConfirmDelete(record)}>
                                    <Icon type="delete" />
                                </IconButton>
                            </Tooltip> : null
                    }
                    <Tooltip title="Editar">
                        <IconButton className={classes.editIcon} onClick={() => props.editSystem(record)}>
                            <Icon type={siteId === "HUB" ? "edit" : "eye"} />
                        </IconButton>
                    </Tooltip>

                </div>
            )
        }
    ];

    return (
        <div>
            <Table
                loading={isLoadListSystems}
                columns={columns}
                dataSource={dataSource}
                pagination={paginationTable}
                scroll={dtsize}
                size={"small"}
                onChange={handleTableChange}
            />
        </div>
    )
}

export default TableScreen;
